













































import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobServiceForm } from '@/models/jobServiceForm/jobServiceForm';
import { JobServiceFormRequest } from '@/models/jobServiceForm/jobServiceFormRequest';
import { SignatureRequest } from '@/models/jobServiceForm/signatureRequest';
import RiskMatrixItemForm from '@/components/jobServiceForm/RiskMatrixItemForm.vue';
import SignOffField from '@/components/jobServiceForm/SignOffField.vue';
import Nullable from '@/types/nullable';
import { vxm } from '@/stores';
import { RiskMatrixOptions } from '../../models/jobServiceForm/riskMatrixOptions';
@Component({
  components: {
    RiskMatrixItemForm,
    SignOffField
  }
})
export default class JobServiceFormEdit extends Vue {
  @Prop({ type: Object, default: null }) public data!: JobServiceFormRequest;
  @Prop({ type: Object, default: null }) public loadedForm!: Nullable<JobServiceForm>;
  @Prop({ type: Object, default: null }) public riskMatrixOptions!: Nullable<RiskMatrixOptions>;

  private expanded: boolean = false;

  $refs!: {
    riskMatrixItem: RiskMatrixItemForm[];
  }

  add(){
    this.data.riskMatrix.push({
      workActivity: 0,
      risks: "",
      riskScore: 0,
      controlMeasures: "",
      residualRiskScore: 0,
      riskRisks: [],
      riskControlMeasures: [],
      workActivityFreeText: "",
      jobDefault: false
    });

    this.$nextTick(() => {
      this.$refs.riskMatrixItem[this.data.riskMatrix.length - 1].edit();
    });
  }

  get loggedInUser(){
    return vxm.user.id
  }

  get technicianSignatureSignedAt(){
    if(this.data.riskMatrixSignOff != null){
      return this.data.riskMatrixSignOff.signedAt;
    }

    if(this.loadedForm != null && this.loadedForm.riskMatrixSignOffs != null){
      let riskMatrixSignOff = this.loadedForm.riskMatrixSignOffs.find(x => x.technician.id === this.loggedInUser);
      if(riskMatrixSignOff != null){
        return riskMatrixSignOff.signedAt;
      }
    }

    return null;
  }

  get technicianSignatureSignedAs(){
    if(this.data.riskMatrixSignOff != null){
      return this.data.riskMatrixSignOff.signedAs;
    }

    if(this.loadedForm != null && this.loadedForm.riskMatrixSignOffs != null){
      let riskMatrixSignOff = this.loadedForm.riskMatrixSignOffs.find(x => x.technician.id === this.loggedInUser);
      if(riskMatrixSignOff != null){
        return riskMatrixSignOff.signedAs;
      }
    }

    return null;
  }

  get technicianSignatureUri(){
    if(this.data.riskMatrixSignOff != null){
      return this.data.riskMatrixSignOff.base64;
    }

    if(this.loadedForm != null && this.loadedForm.riskMatrixSignOffs != null){
      let riskMatrixSignOff = this.loadedForm.riskMatrixSignOffs.find(x => x.technician.id === this.loggedInUser);
      if(riskMatrixSignOff != null){
        return riskMatrixSignOff.uri;
      }
    }

    return null;
  }

  updateTechnicianJobCompleteSignOff(signOff: SignatureRequest){
    this.data.riskMatrixSignOff = signOff;
  }

  get otherTechnicianSignOffs(){
    if(this.loadedForm != null && this.loadedForm.riskMatrixSignOffs != null){
      return this.loadedForm.riskMatrixSignOffs.filter(x => x.technician.id !== this.loggedInUser);
    }

    return [];
  }
}

